<template>
    <div class="container mt-3 px-0">
        <div class="row">
            <template v-if="this.Members">
                <template v-for="(member,index) in this.Members" :key="index">
                    <member-card :Member="member"/>
                </template>
            </template>                
        </div>
    </div>
</template>
<script>
    import axios from 'axios'
    import getEndPoint, { teamMembersAPI } from '../../constants/api.config'
    import MemberCard from '../atoms/MemberCard.vue'
    export default {
        name: "MembersList",
        components: {
            MemberCard
        },
        data() {
            return {
                Members: []
            }
        },
        methods: {
            getMembers(data) {
                let b = [];
                data.forEach(element => {
                    b.push(
                        {
                            MemberID: element.id,
                            DealerLocationID: element.dealerLocationID,
                            Name: element.name,
                            Position: element.position,
                            PhotoURL: element.photoURL,
                            ProfileInfo: element.profileInfo
                        }
                    );
                });

                return b;
            },
            BindMembersData()
            {
                axios.get(getEndPoint(teamMembersAPI) + window.DEALER_LOCATION.dealerLocationID)
                    .then((response) => {
                        this.Members = this.getMembers(response.data);
                    })
                    .catch((error) => console.log(error));               
            }
        },
        mounted() {
            this.BindMembersData();
        }
    }
</script>
<style lang="scss">
</style>